import { useState, useRef } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';

const testimonials = [
  {
    id: 1,
    name: '小林',
    role: '职场白领 · 28岁',
    content: '以前买内裤都是随便挑，穿几天就不舒服了。看了这个网站才知道材质和尺码有多重要。现在按指南选的纯棉内裤，真的太舒服了！',
    rating: 5,
  },
  {
    id: 2,
    name: '阿雅',
    role: '全职妈妈 · 32岁',
    content: '生完宝宝后体型变化很大，之前的尺码都不合适了。按照网站上的尺码指南重新测量选购，穿上终于舒服了。推荐给所有妈妈！',
    rating: 5,
  },
  {
    id: 3,
    name: 'Michelle',
    role: '健身教练 · 25岁',
    content: '运动内裤那篇文章太专业了！按照建议换了速干材质后，运动时再也不会觉得闷热潮湿。已经推荐给所有学员了。',
    rating: 5,
  },
  {
    id: 4,
    name: '小鹿',
    role: '大学生 · 21岁',
    content: '学生党预算有限，那篇平价品牌对比帮了大忙。买到了性价比超高的内裤，好穿又好看，闺蜜都被我安利了。',
    rating: 5,
  },
  {
    id: 5,
    name: '王女士',
    role: '自由职业者 · 35岁',
    content: '蕾丝内裤保养那篇真的很实用，以前买回来洗几次就变形，现在按照方法保养，穿了半年还跟新的一样。',
    rating: 4,
  },
  {
    id: 6,
    name: 'Lisa',
    role: '时尚博主 · 29岁',
    content: '内容专业度很高，材质对比那篇文章让我学到了很多以前不知道的东西。把科普和推荐结合得很好，没有硬广的感觉。',
    rating: 5,
  },
];

const stats = [
  { number: '50+', label: '实测品牌' },
  { number: '200+', label: '原创文章' },
  { number: '10万+', label: '月均读者' },
  { number: '98%', label: '好评率' },
];

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');
  const [charCount, setCharCount] = useState(0);
  const formRef = useRef<HTMLFormElement>(null);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    const honeypotField = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypotField && honeypotField.value.trim() !== '') {
      setFormStatus('success');
      setTimeout(() => setFormStatus('idle'), 3000);
      return;
    }

    setFormStatus('loading');
    setFormError('');

    try {
      const formData = new FormData(form);
      const response = await fetch('https://readdy.ai/api/form/d9s934snlsngrm4lmie0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
        setCharCount(0);
        setTimeout(() => setFormStatus('idle'), 4000);
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText;
        setFormError(serverMsg || '提交失败，请稍后再试');
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查网络后重试');
      setFormStatus('error');
    }
  };

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-16">
        <Breadcrumb items={[{ label: '关于我们' }]} />

        <section className="w-full py-12 md:py-16 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h1 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-6 text-center">
              关于我们
            </h1>

            <div className="prose-custom max-w-none">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mt-8 mb-4">品牌故事</h2>
              <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
                内裤精选指南诞生于2023年，由一群关注女性生活品质的编辑团队创立。我们深知，内裤虽小，却是女性日常舒适体验的关键所在。一条合适的内裤能让一整天都轻松自在，而一条不合适的内裤则可能带来无尽的烦恼。
              </p>
              <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
                我们的团队花费大量时间研究内裤的材质特性、款式设计、品牌差异和用户真实体验。所有评测文章均基于真实购买和实际穿着体验，拒绝任何未经使用的纸上谈兵。
              </p>
              <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
                我们相信，选对内裤不是奢侈，而是每一位女性对自己最基本的关爱。舒适与时尚并不矛盾——我们的使命就是帮你在两者之间找到完美的平衡。
              </p>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 my-10">
                {stats.map((stat) => (
                  <div key={stat.label} className="text-center p-5 bg-background-100 rounded-lg">
                    <div className="font-heading text-2xl md:text-3xl font-bold text-primary-500 mb-1">{stat.number}</div>
                    <div className="text-foreground-600 text-xs md:text-sm">{stat.label}</div>
                  </div>
                ))}
              </div>

              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mt-10 mb-4">用户口碑</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-10">
                {testimonials.map((t) => (
                  <div key={t.id} className="bg-background-100 border border-background-200/60 rounded-lg p-5">
                    <div className="flex items-center mb-3">
                      <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center mr-3">
                        <span className="font-heading text-primary-500 font-semibold text-sm">
                          {t.name.charAt(0)}
                        </span>
                      </div>
                      <div>
                        <div className="font-medium text-foreground-900 text-sm">{t.name}</div>
                        <div className="text-foreground-500 text-xs">{t.role}</div>
                      </div>
                    </div>
                    <p className="text-foreground-600 text-sm leading-relaxed mb-3">
                      &ldquo;{t.content}&rdquo;
                    </p>
                    <div className="flex items-center">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <span key={i} className="w-4 h-4 flex items-center justify-center">
                          <i className={`text-xs ${i < t.rating ? 'text-accent-500 ri-star-fill' : 'text-foreground-300 ri-star-line'}`}></i>
                        </span>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mt-10 mb-4">联系我们</h2>
              <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-6">
                如果你有任何关于内裤选购的疑问，或者想与我们合作，欢迎通过以下表单联系我们。我们通常会在24小时内回复。
              </p>
            </div>

            <div className="bg-background-100 border border-background-200/60 rounded-lg p-6 md:p-8 max-w-2xl">
              <form ref={formRef} onSubmit={handleSubmit} data-readdy-form="">
                <div className="space-y-5">
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-foreground-800 mb-1.5">
                      你的名字 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      required
                      className="w-full px-4 py-2.5 rounded-md border border-background-200 bg-white text-sm text-foreground-900 placeholder-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 transition-all"
                      placeholder="请输入你的名字"
                    />
                  </div>

                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-foreground-800 mb-1.5">
                      电子邮箱 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required
                      className="w-full px-4 py-2.5 rounded-md border border-background-200 bg-white text-sm text-foreground-900 placeholder-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 transition-all"
                      placeholder="请输入你的邮箱地址"
                    />
                  </div>

                  <div>
                    <label htmlFor="message" className="block text-sm font-medium text-foreground-800 mb-1.5">
                      留言内容 <span className="text-primary-500">*</span>
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      required
                      maxLength={500}
                      rows={5}
                      onChange={(e) => setCharCount(e.target.value.length)}
                      className="w-full px-4 py-2.5 rounded-md border border-background-200 bg-white text-sm text-foreground-900 placeholder-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 transition-all resize-none"
                      placeholder="请输入你想说的话（最多500字）"
                    ></textarea>
                    <div className="flex justify-end mt-1">
                      <span className="text-xs text-foreground-500">{charCount}/500</span>
                    </div>
                  </div>

                  <div className="honeypot-field">
                    <input
                      type="text"
                      name="phone_alt"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                      readOnly
                    />
                  </div>

                  <button
                    type="submit"
                    disabled={formStatus === 'loading'}
                    className="w-full py-3 rounded-md bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 cursor-pointer whitespace-nowrap"
                  >
                    {formStatus === 'loading' ? (
                      <span className="flex items-center justify-center">
                        <i className="ri-loader-4-line animate-spin mr-2"></i>
                        提交中...
                      </span>
                    ) : (
                      '发送留言'
                    )}
                  </button>
                </div>

                {formStatus === 'success' && (
                  <div className="mt-4 p-4 rounded-md bg-secondary-50 border border-secondary-200/60 text-secondary-800 text-sm text-center">
                    <i className="ri-checkbox-circle-line mr-1.5"></i>
                    感谢你的留言！我们会在24小时内回复。
                  </div>
                )}

                {formStatus === 'error' && formError && (
                  <div className="mt-4 p-4 rounded-md bg-primary-50 border border-primary-200/60 text-primary-700 text-sm text-center">
                    <i className="ri-error-warning-line mr-1.5"></i>
                    {formError}
                  </div>
                )}
              </form>
            </div>
          </div>
        </section>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'AboutPage',
              name: '关于我们 - 内裤精选指南',
              description: '了解内裤精选指南的品牌故事、团队背景、用户口碑与联系方式。专注女性内裤选购指南的内容平台。',
              url: 'https://www.example.com/about',
              publisher: {
                '@type': 'Organization',
                name: '内裤精选指南',
              },
            }),
          }}
        />
      </main>
      <Footer />
    </>
  );
}